import React from 'react'

/* Styles */
import './SearchCompetitor.css'

/* Components */
import CompetitorsList from '../shared/competitorsList/CompetitorsList'

/* Modules */
import { Breadcrumb, Modal, Button, Spin, Avatar } from 'antd'
import { Link } from 'react-router-dom'
import TopBar from '../topBar/TopBar'

const SearchCompetitorView = (props) => {

    let arrayOfTeamsWithScore = props.arrayOfTeamsWithScore.map((team, index) => {
        if (team.score !== 0) {
            return (
                <div key={team.__key} style={{ backgroundColor: (index % 2 === 0 ? 'rgb(241, 241, 241)' : null) }}>
                    <div className='SearchCompetidorScoreDiv'>
                        {team.nome}
                    </div>

                    <div className='SearchCompetidorScoreDiv'>
                        {team.score}
                    </div>

                    <div style={{ clear: 'both' }}></div>
                </div>
            )
        } else { return null }

    })

    let arrayOfFaixas = props.arrayOfFaixas.map((faixa, index) => {
        return (
            <div key={index} style={{ marginBottom: '10px' }}>
                <Avatar style={{ backgroundColor: faixa.nome }} size='small' /> &nbsp; &nbsp; {faixa.sum}
            </div>
        )
    })

    let arrayOfPesos = props.arrayOfPesos.map((peso, index) => {
        return (
            <div key={index} style={{ marginBottom: '10px' }}>
                <b>{peso.nome}:</b> &nbsp; {peso.sum}
            </div>
        )
    })

    return (
        <div id='champContent'>

            <TopBar />
            <div style={{ height: '70px' }}></div>

            <div className="champsBlock">
                <Breadcrumb>
                    <Breadcrumb.Item><Link to={'/home'}>Início</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs', state: { userType: props.userType } }}>
                            Campeonatos
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs/' + props.champId }}>
                            {props.champObject.nome}
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Consulta</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className='HomeContent'>
                <div className='SearchCompetitorList'>
                    <div>
                        <div className='SearchCompetidorTag'>
                            <a onClick={() => props.openInfoModal()}>
                                Ver resumo
                            </a>
                        </div>
                        <div className='SearchCompetidorTag'>
                            <a onClick={() => props.openScoreModal()}>
                                Ver pontuação
                            </a>
                        </div>
                    </div>
                    <CompetitorsList
                        champ={props.champObject}
                        champId={props.champId}
                        arrayOfTeams={props.arrayOfTeams}
                        render={true}
                    />
                </div>
            </div>

            <Modal
                title='Resumo'
                visible={props.infoModal}
                onCancel={props.closeInfoModal}
                footer={[
                    <Button key='close' onClick={props.closeInfoModal}>Fechar</Button>
                ]}
            >
                <p style={{ marginBottom: '20px', fontSize: 'larger' }}>
                    Resumo |&nbsp;
                    <span style={{ fontSize: 'small' }}>
                        Total de inscritos: {props.sumOfStudentsAddedInChamp}
                    </span>
                </p>
                {props.loadingSum ? <Spin style={{ width: '100%', marginTop: '20px', marginBottom: '20px' }} /> :
                    <div>
                        <div style={{ float: 'left', width: '40%' }}>
                            {arrayOfFaixas}
                        </div>
                        <div style={{ float: 'left', width: '60%' }}>
                            {arrayOfPesos}
                        </div>
                    </div>
                }
                <div style={{ clear: 'both' }}></div>
            </Modal>

            <Modal
                title='Pontuação'
                visible={props.scoreModal}
                onCancel={props.closeScoreModal}
                footer={[
                    <Button key='close' onClick={props.closeScoreModal}>Fechar</Button>
                ]}
            >
                <div>
                    <div>
                        <div className='SearchCompetidorScoreDiv' style={{ fontWeight: 'bold' }}>
                            Nome
                        </div>

                        <div className='SearchCompetidorScoreDiv' style={{ fontWeight: 'bold' }}>
                            Pontuação
                        </div>

                        <div style={{ clear: 'both' }}></div>
                    </div>
                    {props.loadingArrayOfTeams ? <Spin style={{ width: '100%', marginTop: '10px' }} /> : arrayOfTeamsWithScore}
                </div>
            </Modal>
        </div>
    )
}

export default SearchCompetitorView